// Premium 3-line revenue trajectory chart using Recharts
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

const MONTH_LABELS = ["M1","M2","M3","M4","M5","M6","M7","M8","M9","M10","M11","M12"];

const formatUsd = (v) => {
  if (v == null) return "";
  const abs = Math.abs(v);
  if (abs >= 1000) return `$${Math.round(v / 100) / 10}K`;
  return `$${v}`;
};

export default function RevenueScenarioChart({ trajectory }) {
  if (!trajectory) return null;
  const data = MONTH_LABELS.map((m, i) => ({
    month: m,
    status_quo: trajectory.status_quo?.[i] ?? 0,
    with_playbook: trajectory.with_playbook?.[i] ?? 0,
    with_playbook_plus_call: trajectory.with_playbook_plus_call?.[i] ?? 0,
  }));
  return (
    <div className="w-full h-96 md:h-80" data-testid="revenue-scenario-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 20, right: 20, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(212,175,55,0.08)" vertical={false} />
          <XAxis dataKey="month" stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={{ stroke: "rgba(212,175,55,0.15)" }} />
          <YAxis stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} tickFormatter={formatUsd} width={60} />
          <Tooltip
            contentStyle={{ backgroundColor: "#0F172A", border: "1px solid rgba(212,175,55,0.3)", borderRadius: 0, fontSize: 12 }}
            labelStyle={{ color: "#F8FAFC" }}
            itemStyle={{ color: "#F8FAFC" }}
            formatter={(value, name) => [`$${Number(value).toLocaleString()}/mo`, ({
              status_quo: "Status quo",
              with_playbook: "With playbook",
              with_playbook_plus_call: "Playbook + strategy call",
            })[name]]}
          />
          <Legend
            verticalAlign="bottom"
            iconType="plainline"
            wrapperStyle={{ fontSize: 12, color: "#CBD5E1", paddingTop: 16 }}
            formatter={(value) => ({
              status_quo: "Do nothing",
              with_playbook: "Self-implement playbook",
              with_playbook_plus_call: "Playbook + strategy call",
            })[value]}
          />
          <Line type="monotone" dataKey="status_quo" stroke="#EF4444" strokeWidth={1.5} strokeDasharray="4 4" dot={false} />
          <Line type="monotone" dataKey="with_playbook" stroke="#94A3B8" strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="with_playbook_plus_call" stroke="#D4AF37" strokeWidth={2.5} dot={{ r: 3, fill: "#D4AF37", stroke: "#0F172A", strokeWidth: 1 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
